import React, { FunctionComponent, useState } from "react"
import {
  Flex,
  Box,
  Input,
  Heading,
  Text,
  Alert,
  AlertIcon,
  CloseButton,
} from "@chakra-ui/react"
import { colors } from "../../theme/theme"
import styled from "@emotion/styled"
import { useForm } from "react-hook-form"
import CustomButton from "../CustomButton"
import ReCAPTCHA from "react-google-recaptcha"
// @ts-ignore
import addToMailchimp from "gatsby-plugin-mailchimp"

const StyledAlert = styled(Alert)`
  background-color: ${colors.green};
  color: ${colors.white};
`

const StyledBox = styled(Box)`
  max-width: 35rem;
  width: 100%;
  align-content: center;
  align-items: center;
`

interface INewsletterSignupProps {
  styles?: React.CSSProperties
}

interface ISignupSate {
  result: string
  msg: string
}

export const NewsletterSignup: FunctionComponent<INewsletterSignupProps> = ({
  styles,
}) => {
  const [signupState, setSignupState] = useState<ISignupSate | null>(null)
  const [showRecaptcha, setShowRecaptcha] = useState<boolean>(false)
  const [userEmail, setUserEmail] = useState<string>("")

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const handleRecaptcha = async () => {
    try {
      const subscribe: ISignupSate = await addToMailchimp(userEmail)
      setSignupState(subscribe)
    } catch (e) {
      setSignupState({ result: "error", msg: "Something went wrong" })
    }
  }

  const onSubmit = async ({ email }: any) => {
    // TODO: Clean the email input
    setShowRecaptcha(true)
    setUserEmail(email)
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{
        width: "100%",
        padding: "1.5rem 0",
      }}
      noValidate={true}
    >
      <Flex
        flexDir="column"
        width="100%"
        style={styles}
        justifyContent="center"
        alignItems="center"
        alignContent="center"
      >
        <StyledBox style={{ paddingBottom: "1.25rem" }}>
          <Heading
            as="h3"
            textAlign="center"
            fontSize="1.4rem"
            color={colors.grey.dark}
          >
            Sign up and never miss a post
          </Heading>
        </StyledBox>
        <StyledBox style={{ padding: "0.25rem 0" }}>
          <Flex
            flexDir="column"
            width="100%"
            style={styles}
            justifyContent="center"
            alignItems="center"
            alignContent="center"
          >
            <StyledBox style={{ paddingBottom: "0.25rem" }}>
              <Input
                placeholder="Email"
                type="email"
                id="email"
                {...register("email", {
                  required: "required",
                  pattern: {
                    value: /\S+@\S+.\S+/,
                    message: "Entered value does not match email format",
                  },
                })}
                color={colors.grey.mediumDark}
              />
            </StyledBox>
            <StyledBox>
              {errors.email && (
                <Text fontSize="0.8rem" color={colors.red}>
                  *{" "}
                  {errors.email.message == "required"
                    ? "Your email is required"
                    : errors.email.message}
                </Text>
              )}
            </StyledBox>
            <StyledBox>
              {signupState && signupState.result == "success" && (
                <StyledAlert status="success">
                  <AlertIcon />
                  Success! Thanks for signing up!
                  <CloseButton
                    position="absolute"
                    right="8px"
                    top="8px"
                    onClick={() => {
                      setSignupState(null)
                    }}
                  />
                </StyledAlert>
              )}
              {signupState && signupState.result !== "success" && (
                <Text fontSize="0.8rem" color={colors.red}>
                  An error occured while signing you up...
                </Text>
              )}
            </StyledBox>
          </Flex>
        </StyledBox>
        <StyledBox style={{ paddingTop: "0.5rem" }}>
          <CustomButton
            text="Sign up"
            type="submit"
            styles={{ width: "100%" }}
          />
        </StyledBox>
        {showRecaptcha && (
          <Flex>
            <StyledBox style={{ paddingTop: "0.5rem" }}>
              <ReCAPTCHA
                sitekey={
                  process.env.GATSBY_RECAPTCHA_SITE_KEY
                    ? process.env.GATSBY_RECAPTCHA_SITE_KEY
                    : ""
                }
                onChange={handleRecaptcha}
              />
            </StyledBox>
          </Flex>
        )}
      </Flex>
    </form>
  )
}

export default NewsletterSignup
